import { StrapiMedia } from '../strapi-media'

import * as styles from './store-button.styles'

type StoreButtonProps = {
  variant?: 'regular' | 'small'
  url?: string
  storeLogo?: {
    url?: string
    width?: number
    height?: number
  }
}

export const StoreButton = ({
  url,
  storeLogo,
  variant = 'regular',
}: StoreButtonProps) => (
  <a css={styles[variant]} href={url} rel="noreferrer" target="_blank">
    <StrapiMedia {...storeLogo} />
  </a>
)
